import { onlineClassesPath } from "@outschool/routes";

import { CategoryPartial } from "./navbarCategories";

/**
 * Gets the URL for a category, using the custom path if available or generating one from the slug
 */
export function getCategoryUrl(category: CategoryPartial): string {
  return category.path || onlineClassesPath(category.slug, category.basePath);
}

/**
 * Checks if a category has subcategories
 */
export function hasSubcategories(category: CategoryPartial): boolean {
  return Boolean(
    category.subcategories && category.subcategories?.().length > 0,
  );
}
